import { SearchMarkedText } from "@ext/serach/components/results/SearchMarkedText";
import type { SearchResultMarkItem } from "@ext/serach/Searcher";
import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbSeparator } from "@ui-kit/Breadcrumb";
import { Fragment } from "react";

export interface SearchResultHeaderItemProps {
	breadcrumbs: SearchResultMarkItem[][];
}

export const SearchResultHeaderItem = (props: SearchResultHeaderItemProps) => {
	const { breadcrumbs } = props;

	return (
		<div className="px-2.5 py-1.5 font-medium leading-5">
			<Breadcrumb>
				<BreadcrumbList className="text-sm">
					{breadcrumbs.map((x, i) => {
						const isLast = i === breadcrumbs.length - 1;
						const addSeparator = !isLast;
						return (
							// biome-ignore lint/suspicious/noArrayIndexKey: idc
							<Fragment key={i}>
								<BreadcrumbItem className="p-0 text-secondary-fg">
									<span>
										<SearchMarkedText marks={x} />
									</span>
								</BreadcrumbItem>
								{addSeparator && (
									<BreadcrumbSeparator>
										<span className="text-muted">/</span>
									</BreadcrumbSeparator>
								)}
							</Fragment>
						);
					})}
				</BreadcrumbList>
			</Breadcrumb>
		</div>
	);
};
